import React, { useState, useEffect } from "react"
import { Container } from "react-bootstrap"
import parse from 'html-react-parser';
import axios from "axios"
import Slider from "react-slick"
import ReactReadMoreReadLess from "react-read-more-read-less"
import { StarYellow } from "@Components/icon/icon"

import "./ReviewSlider.scss"

const ReviewSlider = ({ Title, Content, Name }) => {
  const [reviews, setReviews] = useState([])

  const strapiconfig = {
    headers: {
      Authorization: `Bearer ${process.env.GATSBY_STRAPI_FORM_TOKEN}`,
    },
  }

  const fetchReviews = async () => {
    try {
      const url = `${process.env.GATSBY_STRAPI_SRC}/stb-google-reviews/google-review-reviews`
      const { data } = await axios.get(url, strapiconfig)
      setReviews(data || [])
    } catch (err) {
      console.error("Reviews fetch error:", err)
    }
  }

  useEffect(() => {
    fetchReviews()
  }, [])

  const settings = {
    arrows: false,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  }

  const renderStars = (rating) => {
    const map = { ONE: 1, TWO: 2, THREE: 3, FOUR: 4, FIVE: 5 }
    const count = map[rating] || 5

    return [...Array(count)].map((_, i) => <StarYellow key={i} />)
  }

  if (!reviews || reviews.length === 0) return null;

  return (
    <section className="review-slider-section">
      <Container>
        <div className="review-slider-header">
          {Title && <h2 className="review-title">{Title}</h2>}
          {Content && <div className="description">{parse(Content)}</div>}
        </div>

        <Slider {...settings} className="review-slider">
          {reviews
            .filter((r) => r.comment)
            .slice(0, 10)
            .map((item, i) => (
              <div key={i} className="review-item">
                <div className="review-card">
                  <div className="stars">
                    {renderStars(item.starRating)}
                  </div>

                  <div className="review-text">
                    <ReactReadMoreReadLess
                      charLimit={150}
                      readMoreText="read more"
                      readLessText="read less"
                      readMoreClassName="read-more"
                      readLessClassName="read-less"
                    >
                      {item.comment}
                    </ReactReadMoreReadLess>
                  </div>

                  <div className="review-user">
                    <div>
                      <strong>{item?.reviewer?.displayName}</strong>
                      <span>For the {Name} office</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </Slider>
      </Container>
    </section>
  )
}

export default ReviewSlider